import { GameType } from '@statsbomb/parachute-types';
import { EntityGameWithCompetitionName } from './game';
import { NumberOption, StringOption } from './generic';

export enum TeamType {
  HOME = GameType.HOME,
  AWAY = GameType.AWAY,
}

export interface PositionOption extends StringOption {
  other?: boolean;
}

export interface SelectorProps<T = NumberOption> {
  options?: T[];
  isLoading?: boolean;
  isMulti?: boolean;
}

export interface GamesBySeason {
  seasonId: number;
  seasonName: string;
  games: EntityGameWithCompetitionName[];
}
